
  <!-- <mandatory-documents [miDocument]="config" [isDynamicComponent]="true" [configOptions]="{PARENT_CONFIG: PARENT_STAGE_STEP_CONFIG}"
  (outputUploadAction)="uploadAction($event)"></mandatory-documents> -->

  <document-upload [miDocument]="config" [isDynamicComponent]="true"></document-upload>

